import { Footer, FooterButtons } from '@/design_system/Footer';

import { CreateShipmentButton } from './shared/CreateShipmentButton';
import { ValidateTransitFromToNonDigitalizedWorkshopButton } from './shared/ValidateTransitFromToNonDigitalizedWorkshopButton';
import { ArticleActionProps } from './ArticleActions';

export const ValidateTransitAction = ({ onActionDone }: ArticleActionProps) => {
  return (
    <Footer>
      <FooterButtons>
        <CreateShipmentButton variant="secondary" />
        <ValidateTransitFromToNonDigitalizedWorkshopButton onActionDone={onActionDone} />
      </FooterButtons>
    </Footer>
  );
};
